// src/pages/UploadPage.jsx
import { useState } from "react";
import { useApiClient } from "../apiClient";

export default function UploadPage() {
  const { authorizedFetch } = useApiClient();
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    if (!file) {
      setStatus({ type: "error", message: "Please select a file to upload." });
      return;
    }
    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploading(true);
      await authorizedFetch("/books/upload", {
        method: "POST",
        body: formData,
        // Note: no need to manually set Content-Type, browser will set boundary
      });

      setStatus({ type: "success", message: "Book uploaded successfully!" });
      setFile(null);
    } catch (err) {
        console.error("Upload error:", err);
      setStatus({
        type: "error",
        message: err.message || "Upload failed",
      });
    } finally {
      setUploading(false);
    }
  };

  return (
    <section className="page">
      <h1>Upload eBook</h1>
      <p className="page-subtitle">
        Add a new eBook to the library by uploading a file and providing basic
        details.
      </p>

      <form className="form" onSubmit={handleSubmit}>
        {status.message && (
          <div
            className={
              status.type === "error" ? "alert alert-error" : "alert alert-ok"
            }
          >
            {status.message}
          </div>
        )}

        <div className="form-group">
          <label htmlFor="file">eBook file (PDF/EPUB/MOBI)</label>
          <input id="file" type="file" onChange={handleFileChange} required />
          {file && <small>Selected: {file.name}</small>}
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={uploading}
        >
          {uploading ? "Uploading..." : "Upload eBook"}
        </button>
      </form>
    </section>
  );
}